// extracted by mini-css-extract-plugin
export var closeButton = "_kx-1";
export var closeX = "_kx-3";
export var container = "_kx-0";
export var image = "_kx-2";